// 点击区域外
export const clickOutside = {
  mounted(el, binding) {
    function eventHandler(e) {
      if (el.contains(e.target)) {
        return false;
      }
      const p = e.target.closest("body");
      if (p && binding.value && typeof binding.value === "function") {
        binding.value(e);
      }
    }
    el.Tag = eventHandler;
    document.addEventListener("click", eventHandler);
  },
  beforeUnmount(el) {
    document.removeEventListener("click", el.Tag);
    delete el.Tag;
  }
};
